export const getWebsocketUrl = (channelName) => {
    const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    const originalHost = window.location.host;
    const isLocalhost = originalHost === 'localhost:3000' || originalHost === 'localhost:3001';
    const host = isLocalhost ? 'localhost:8081' : originalHost;
    return `${protocol}://${host}/api/wss/${channelName}`;
};

export function isMoneyHostname() {
    const {hostname, port} = window.location;

    if (hostname === 'localhost') {
        return port === '3000';
    }

    return hostname === 'flextagram.com' ||
        hostname === 'www.flextagram.com';
}

export function getImageUrl(id, imageType) {
    const {hostname, port} = window.location;
    const isLocal = hostname === 'localhost';
    if (isLocal) {
        return 'http://' + hostname + ':' + port + '/api/image/' + imageType + '/' + id;
    } else {
        const hostname = isMoneyHostname() ? 'flextagram' : 'flexagren';
        return 'https://assets.' + hostname + '.com/' + id + '_' + imageType + '.png';
    }
}